import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    imports: [FontAwesomeModule, ButtonModule, NgClass, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class IconButtonComponent implements OnInit, OnChanges {


  @Input() icon!: IconDefinition

  @Input() buttonType: "primary" | "secondary" | "danger" | "warning" | "info" | "help" | "text" | "success" = "text"
  @Input() textSize: "text-xs" | "text-sm" | "text-base" | "text-lg" | "text-xl" | "text-2xl" | "text-3xl" | "text-4xl" | "text-5xl" = "text-base"
  @Input() disabled = false;
  @Input() text = true
  @Input() size: "sm" | "md" | "lg" | "" = ""
  @Input() href?: string;
  @Input() routerLink?: string | any[];
  @Input() target: string = '_self';
  
  spin = input<boolean>(false)

  animation = computed(() => {
    const spin = this.spin()

    if (spin) {
      return 'spin'
    }
    
    return undefined
  })

  myClass: string = ""

  @Output() onClick = new EventEmitter<any>()

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['buttonType'] || changes['textSize'] || changes['size']) {
      this.setButtonClass()
    }
  }

  ngOnInit(): void {
    this.setButtonClass()
  }

  setButtonClass() {
    const sizeClass = this.size ? ` icon-button-${this.size}` : '';
    this.myClass = this.textSize + " " + `${this.buttonType}-background` + sizeClass;
  }

  onButtonClick(event: any) {
    if (!this.disabled && !this.href && !this.routerLink) {
      this.onClick.emit(event)
    }
  }

}
